module.exports = __webpack_public_path__ + "img/kanban04.13c246e8.png";